/**
 * Checks whether all the words in a search are contained in any of the strings in a list.
 * Useful for filtering entries in a table, by passing the displayed values in each column as the values-array.
 * For minor performance improvements, the values can be sorted by how quickly they are expected to match words in the filter.
 * So longer or less frequently searched strings should be towards the end of the array.
 *
 * @function
 * @param values - strings to search through
 * @param filter - the words that should be covered by values
 */
export const doesListSatisfyFilter = (values: string[], filter: string) => {
  const terms = filter
    .toLowerCase()
    .split(" ")
    .filter((term) => term.length > 0)
    .sort((a, b) => b.length - a.length);
  values = values.map((value) => value.toLowerCase());
  termIteration: for (let i = 0; i < terms.length; i++) {
    const term = terms[i];
    for (let j = 0; j < values.length; j++) {
      const matchStart = values[j].indexOf(term);
      if (matchStart == -1) continue;
      values[j] =
        values[j].slice(0, matchStart) +
        values[j].slice(matchStart + term.length);
      continue termIteration;
    }
    return false;
  }
  return true;
};
